import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

/**
 * 발송 모수(Layer 1) picker 전용 목록.
 *
 * 기존 `listBenefit` / `getProjectList` 와 **소스가 같지만 응답이 다르다** —
 * picker 는 이름만으로 고를 수 없어서(2026-08-28 피드백) 식별 정보를 더 받는다.
 * 다른 화면의 응답을 키우지 않기 위해 별도 엔드포인트로 분리했다.
 */
export const getPoolBenefits = async () => {
  const res = await fetchApi.get(API_URL.POOL_OPTION_BENEFITS);
  return res.status === 200 ? res.data : { data: [] };
};

export const getPoolProjects = async () => {
  const res = await fetchApi.get(API_URL.POOL_OPTION_PROJECTS);
  return res.status === 200 ? res.data : { data: [] };
};
